import firebase from 'firebase'

// constantes do Firebase
// Project Overview - console.firebase.google.com
// Adicionar o Firebase ao seu aplicativo da Web

const config = {
  apiKey: "AIzaSyCqHwBa4UOaaqzx6ZGQtm5ETsKSdd02ctc",
  authDomain: "curso-ml.firebaseapp.com",
  databaseURL: "https://curso-ml.firebaseio.com",
  projectId: "curso-ml",
  storageBucket: "curso-ml.appspot.com",
  messagingSenderId: "843471097225"
};

firebase.initializeApp(config)
export default firebase



// WEBPACK FOOTER //
// ./src/server/firebase.js